<div fxLayoutAlign="center center">
    <h1 mat-dialog-title>{{titulo}}</h1>
</div>
<div mat-dialog-content>
    <p class="titulo-alert">{{mensagem}}</p>
</div>
<div mat-dialog-actions>
    <button class="full-width" mat-button mat-dialog-close>OK</button>
</div>
